import React from 'react';
import makeInIndiaLogo from '../images/makeInIndia.png';

const Footer = () => {
  return (
    <>
      <footer
        style={{
          background: "#fff",
          padding: "4px 12px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderTop: "1px solid #e2e8f0",
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 100,
        }}
      >
        <div
          style={{
            fontSize: "1rem",
            fontWeight: "600",
            color: "#3b2f0dff",
          }}
        >
          Owner Builder Admin Panel
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <span
            style={{
              fontSize: "0.9rem",
              color: "#2d3748",
            }}
          >
            Designed and Developed by
          </span>
          <a
            href="https://aayaninfotech.com/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#574515ff",
              textDecoration: "none",
              fontSize: "0.9rem",
              fontWeight: "500",
              cursor: "pointer",
              transition: "all 0.2s ease",
              padding: "4px 8px",
              borderRadius: "4px",
            }}
            onMouseEnter={(e) => {
              e.target.style.color = "#4e3f19ff";
              e.target.style.backgroundColor = "#f7f4ed";
            }}
            onMouseLeave={(e) => {
              e.target.style.color = "#3f3415ff";
              e.target.style.backgroundColor = "transparent";
            }}
          >
            Aayan Infotech
          </a>
          <img 
            src={makeInIndiaLogo} 
            alt="Make in India" 
            style={{ 
              height: '25px', 
              width: 'auto',
              marginLeft: '8px'
            }} 
          />
        </div>
      </footer>
    </>
  );
};

export default Footer;